import { ITransformRT2, Matrix23 } from '@seddi/math-v2';

export const getTransformMatrix = (transform: ITransformRT2, target: Matrix23): Matrix23 => {
  target.setRotation(transform.rotation);
  target.setTranslationFromFloats(transform.translation.x, transform.translation.y);
  return target;
};

export const getInverseTransformMatrix = (() => {
  const m = new Matrix23();

  return (transform: ITransformRT2, target: Matrix23): Matrix23 => {
    getTransformMatrix(transform, m);
    m.invertToRef(target);
    return target;
  };
})();
